import styled from 'styled-components';
import { FlexColumn } from "../../../../utils/containers";

const ProcessStyle = styled(FlexColumn)`
  h2 {
    margin-bottom: 40px;
  }
`;

export default ProcessStyle;
